import { ApplicationInsights, ITelemetryItem } from '@microsoft/applicationinsights-web';
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';
import { stringOrEmpty } from 'utils/utils';

const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
  config: {
    connectionString: stringOrEmpty(process.env.REACT_APP_AZURE_APP_INSIGHTS_CONNECTION_STRING),
    extensions: [reactPlugin],
    enableAutoRouteTracking: true,
    disableInstrumentationKeyValidation: false,
  },
});

appInsights.loadAppInsights();
appInsights.addTelemetryInitializer((env: ITelemetryItem) => {
  env.tags = env.tags || [];
  env.tags['ai.cloud.role'] = `${stringOrEmpty(process.env.REACT_APP_NAME)}-front-client-${stringOrEmpty(process.env.REACT_APP_ENV)}`;
});

const WithAITracking = (Component: any) => withAITracking(reactPlugin, Component)

export { reactPlugin, appInsights };
export default WithAITracking;
